import wizHelloWorld from './index.vue'

wizHelloWorld.install = (Vue) => {
  Vue.component(wizHelloWorld.name, wizHelloWorld)
}

export default wizHelloWorld